/**
 * Extract model prefix from device name (e.g., "HV0" from "HV0_251106_00000013").
 * Aligned with iOS logic that derives model from the name segment before the first underscore.
 */
export function extractDeviceModel(
  deviceName: string | null | undefined
): string | undefined {
  return deviceName?.split('_')[0] ?? undefined;
}
